import React, { useEffect, useState } from "react";
import { Wrapper, Content, Content1 } from "./header.style";
import { Link } from "react-router-dom";
import SideNav from "../SideNav";
import CloseIcon from "@mui/icons-material/Close";
import { AxiosConnect } from "../../AxiosConnect";
import MENU_BAR from "../../utils/menu";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Wrapper>
        <div className="logo">
          <Link to="/">
            <img src="/images/logo.png" alt="logo" />
          </Link>
        </div>
        <Content>
          {MENU_BAR &&
            MENU_BAR.map((x) => (
              <div>
                <a href={x.link}>{x.company}</a>
              </div>
            ))}
        </Content>
        <Content1>
          <a href="https://devsensor.com" className="none">
            DevSensor
          </a>
          <a href="https://aesthery.com" className="none">
            Aesthery
          </a>
          {/* <a href="https://gernoid.com" className="none">
            Gernoid
          </a> */}
        </Content1>
        {open && (
          <div className="top">
            <div className="close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
        )}
        <SideNav show={open} />
      </Wrapper>
    </>
  );
};

export default Header;
